<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} đánh giá
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="4">
                    <el-form-item label="Người đánh giá" prop="">
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="nguoiGui"
                        :fetch-suggestions="querySearchNguoiGui"
                        placeholder="Nhập từ khóa để tìm kiếm người đánh giá"
                        :trigger-on-focus="false"
                        @select="handleSelectNguoiGui"
                        @change="handleSelectNguoiGui"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <el-form-item label="Đối tượng đánh giá" prop="">
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="doiTuong"
                        :fetch-suggestions="querySearchDoiTuongDanhGia"
                        placeholder="Nhập từ khóa để tìm kiếm đối tượng đánh giá"
                        :trigger-on-focus="false"
                        @select="handleSelectDoiTuongDanhGia"
                        @change="handleSelectDoiTuongDanhGia"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <el-form-item
                      label="Thời điểm đánh giá"
                      prop="thoi_diem_danh_gia"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_diem_danh_gia
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.hien_thi"
                    :placeholder="'Trạng thái hiển thị'"
                    @change="fn_tableSearch()"
                    :default-first-option="true"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listVisible"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.lock"
                    :placeholder="'Trạng thái khoá'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listKhoa"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column label="Khoá" width="60" align="center">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.lock"
                @change="fn_changeTrangThai(scope.row.id, scope.row.lock)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_nguoi_danh_gia"
            label="Người đánh giá"
            :sortable="mData.tableRules.allowSorting"
            min-width="170px"
          >
          </el-table-column>
          <el-table-column
            prop="doi_tuong_danh_gia"
            label="Đối tượng đánh giá"
            :sortable="mData.tableRules.allowSorting"
            min-width="170px"
          >
          </el-table-column>
          <el-table-column
            prop="noi_dung"
            label="Nội dung"
            :sortable="mData.tableRules.allowSorting"
            min-width="150px"
          >
          </el-table-column>
          <el-table-column
            prop="gia_tri"
            label="Số sao"
            :sortable="mData.tableRules.allowSorting"
            width="90px"
          >
            <template slot-scope="scope">
              <div class="text-center">{{ scope.row.gia_tri }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="thoi_diem_danh_gia"
            label="Thời điểm đánh giá"
            :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterDatetime"
            min-width="160px"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{ fn_formatterDatetimeList(scope.row.thoi_diem_danh_gia) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hien_thi"
            label="Trạng thái hiển thị"
            min-width="130px"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.hien_thi ? "Hiển thị" : "Không hiển thị" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataService from "@/service/DataService";
import mushroom from "../../../service/api/dulich-api";
import DanhGiaModel from "@/views/admin/DanhGia/DanhGiaModel";
export default {
  data() {
    return {
      nguoiGui: "",
      doiTuong: "",
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DanhGia", //requied
        tableRules: MethodService.copyObject(DanhGiaModel.tableRules),
        dataDefault: {
          listVisible: DataService.visibleListSearch,
          listServiceType: DataService.serviceTypeList,
          listKhoa: MethodService.copyObject(DanhGiaModel.listKhoaSearch),
          listNguoiDanhGia: [],
          listNguoiDanhGiaKDL: [],
          listNguoiDanhGiaSearch: [],
          listDoiTuongDanhGia: [],
          listDoiTuongDanhGiaTour: [],
          listDoiTuongDanhGiaSearch: [],
        },
      },
    };
  },
  created() {
    this.mData.tableRules.dataSearch.value.hien_thi = "true";
    this.fn_hashUrl();
    this.fn_defaultTableSearch();
  },
  mounted() {},
  methods: {
    async getDanhGiaList() {
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? "&" : "") +
          "danh_gia_id:is_null:true",
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }

      let res = await mushroom.danh_gia.listAsync({
        filters: dataFilter.filters,
        limit: dataFilter.limit,
        offset: dataFilter.offset,
        sort: dataFilter.sort,
      });
      let resData = await this.fn_changeData(res.result);
      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getDanhGiaList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let nguoiDanhGiaIds = [];
      let doiTuongDanhGiaIds = [];
      nguoiDanhGiaIds = MethodService.findListItemDifferent(
        resData,
        "nguoi_danh_gia_id"
      );
      doiTuongDanhGiaIds = MethodService.findListItemDifferent(
        resData,
        "doi_tuong_danh_gia_id"
      );
      const reqNguoiDanhGiaApi = await mushroom.profile.listAsync({
        limit: nguoiDanhGiaIds.length,
        filters: "id:in:" + nguoiDanhGiaIds.join(","),
      });
      const reqNguoiDanhGiaKhachDuLichApi =
        await mushroom.khach_du_lich.listAsync({
          limit: nguoiDanhGiaIds.length,
          filters: "id:in:" + nguoiDanhGiaIds.join(","),
        });
      const reqDichVuApi = await mushroom.tv_dich_vu.listAsync({
        limit: doiTuongDanhGiaIds.length,
        filters: "id:in:" + doiTuongDanhGiaIds.join(","),
      });
      const reqDichVuTourApi = await mushroom.tv_dich_vu_tour.listAsync({
        limit: doiTuongDanhGiaIds.length,
        filters: "id:in:" + doiTuongDanhGiaIds.join(","),
      });

      let resNguoiDanhGiaApi = await reqNguoiDanhGiaApi;
      let resNguoiDanhGiaKDLApi = await reqNguoiDanhGiaKhachDuLichApi;
      let resDichVuApi = await reqDichVuApi;
      let resDichVuTourApi = await reqDichVuTourApi;
      this.mData.dataDefault.listNguoiDanhGia = resNguoiDanhGiaApi.result;
      this.mData.dataDefault.listNguoiDanhGiaKDL = resNguoiDanhGiaKDLApi.result;
      this.mData.dataDefault.listDoiTuongDanhGia = resDichVuApi.result;
      this.mData.dataDefault.listDoiTuongDanhGiaTour = resDichVuTourApi.result;

      resData.forEach(async (item) => {
        let nguoiDanhGia = this.mData.dataDefault.listNguoiDanhGia.find(
          (element) => {
            return element.id == item.nguoi_danh_gia_id;
          }
        );
        let nguoiDanhGiaKDL = this.mData.dataDefault.listNguoiDanhGiaKDL.find(
          (element) => {
            return element.id == item.nguoi_danh_gia_id;
          }
        );
        let doiTuongDanhGia = this.mData.dataDefault.listDoiTuongDanhGia.find(
          (element) => {
            return element.id == item.doi_tuong_danh_gia_id;
          }
        );
        let doiTuongDanhGiaTour =
          this.mData.dataDefault.listDoiTuongDanhGiaTour.find((element) => {
            return element.id == item.doi_tuong_danh_gia_id;
          });
        if (nguoiDanhGia && nguoiDanhGia.ho_ten.ho_ten.trim()) {
          item.ten_nguoi_danh_gia = nguoiDanhGia.ho_ten.ho_ten;
        } else if (
          nguoiDanhGiaKDL &&
          nguoiDanhGiaKDL.ho_ten &&
          nguoiDanhGiaKDL.ho_ten.ho_ten.trim()
        ) {
          item.ten_nguoi_danh_gia = nguoiDanhGiaKDL.ho_ten.ho_ten;
        } else {
          item.ten_nguoi_danh_gia = "Chưa có thông tin";
        }
        if (doiTuongDanhGia) {
          if (doiTuongDanhGia.loai == "yellow_page_place") {
            item.doi_tuong_danh_gia = doiTuongDanhGia.diem_den.ten;
          } else if (
            doiTuongDanhGia.loai == "hotel" ||
            doiTuongDanhGia.loai == "tourist_villa" ||
            doiTuongDanhGia.loai == "tourist_apartment" ||
            doiTuongDanhGia.loai == "tourist_cruise" ||
            doiTuongDanhGia.loai == "camping" ||
            doiTuongDanhGia.loai == "motel" ||
            doiTuongDanhGia.loai == "homestay"
          ) {
            item.doi_tuong_danh_gia = doiTuongDanhGia.luu_tru.ten;
          } else if (doiTuongDanhGia.loai == "restaurant") {
            item.doi_tuong_danh_gia = doiTuongDanhGia.am_thuc.ten;
          } else if (doiTuongDanhGia.loai == "entertainment") {
            item.doi_tuong_danh_gia = doiTuongDanhGia.giai_tri.ten;
          } else if (doiTuongDanhGia.loai == "ticket") {
            item.doi_tuong_danh_gia = doiTuongDanhGia.ve_dien_tu.ten;
          }
        } else if (doiTuongDanhGiaTour) {
          item.doi_tuong_danh_gia = doiTuongDanhGiaTour.ten_tour;
        } else {
          item.doi_tuong_danh_gia = "Chưa có thông tin";
        }
      });
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getDanhGiaList();
    },

    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
            "lock=false",
            "lock!=true"
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getDanhGiaList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_defaultTableSearch() {
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.getDanhGiaList();
    },

    async querySearchNguoiGui(queryString, cb) {
      queryString = queryString.trim();
      // TODO: dulich-api.ts chưa hỗ trợ view suggest_response_user cho danh_gia - cần bổ sung
      // await DanhGiaApi.suggestUser(queryString).then(async (suggestUser) => {
      //   if (suggestUser.result && suggestUser.result.length > 0) {
      //     this.mData.dataDefault.listNguoiDanhGiaSearch = suggestUser.result;
      //   }
      // });
      let results = queryString
        ? this.mData.dataDefault.listNguoiDanhGiaSearch.filter((item) =>
            item.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listNguoiDanhGiaSearch;

      // call callback function to return suggestions
      cb(results);
    },
    async querySearchDoiTuongDanhGia(queryString, cb) {
      queryString = queryString.trim();
      // TODO: dulich-api.ts chưa hỗ trợ view suggest_response_dichvu cho danh_gia - cần bổ sung
      // await DanhGiaApi.suggestDichVu(queryString).then(async (suggestUser) => {
      //   if (suggestUser.result && suggestUser.result.length > 0) {
      //     this.mData.dataDefault.listDoiTuongDanhGiaSearch = suggestUser.result;
      //   }
      // });
      let results = queryString
        ? this.mData.dataDefault.listDoiTuongDanhGiaSearch.filter((item) =>
            item.ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listDoiTuongDanhGiaSearch;

      // call callback function to return suggestions
      cb(results);
    },

    handleSelectNguoiGui(item) {
      this.mData.tableRules.dataSearch.value.nguoi_danh_gia_id =
        item.nguoi_danh_gia_id;
      this.nguoiGui = item.ho_ten;
    },
    handleSelectDoiTuongDanhGia(item) {
      this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id =
        item.doi_tuong_danh_gia_id;
      this.doiTuong = item.ten;
    },

    async fn_changeTrangThai(id, trangThai) {
      let data = {
        id: id,
        lock: trangThai,
      };
      await mushroom.danh_gia.partialUpdateAsync(data);
      this.getDanhGiaList();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getDanhGiaList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    fn_handle(type, scope, row) {
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },
    async fn_delete(id) {
      try {
        await mushroom.danh_gia.deleteAsync(id);
        toastr.success("Xoá thành công!");
        this.getDanhGiaList();
      } catch (error) {
        toastr.error(error.meta.code);
      }
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_formatterDatetimeList(cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
          "lock!=true",
          "lock=false"
        );
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.mData.tableRules.dataSearch.value.nguoi_danh_gia_id) {
        let resProfile = await mushroom.profile.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.nguoi_danh_gia_id,
        });
        if (resProfile.result) {
          this.mData.dataDefault.listNguoiDanhGiaSearch.push(resProfile.result);
          this.nguoiGui = resProfile.result.ho_ten.ho_ten;
        } else {
          let resKhachDL = await mushroom.khach_du_lich.findByIdAsync({
            id: this.mData.tableRules.dataSearch.value.nguoi_danh_gia_id,
          });
          if (resKhachDL.result) {
            this.mData.dataDefault.listNguoiDanhGiaSearch.push(
              resKhachDL.result
            );
            this.nguoiGui = resKhachDL.result.ho_ten.ho_ten;
          }
        }
      }
      if (this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id) {
        let resDichVuApi = await mushroom.tv_dich_vu.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id,
        });
        let resDichVuTourApi = await mushroom.tv_dich_vu_tour.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.doi_tuong_danh_gia_id,
        });
        if (resDichVuApi.result) {
          this.mData.dataDefault.listDoiTuongDanhGiaSearch.push(
            resDichVuApi.result
          );
          if (resDichVuApi.result.loai == "yellow_page_place") {
            this.doiTuong = resDichVuApi.result.diem_den.ten;
          } else if (resDichVuApi.result.loai == "hotel") {
            this.doiTuong = resDichVuApi.result.luu_tru.ten;
          } else if (resDichVuApi.result.loai == "restaurant") {
            this.doiTuong = resDichVuApi.result.am_thuc.ten;
          } else if (resDichVuApi.result.loai == "entertainment") {
            this.doiTuong = resDichVuApi.result.giai_tri.ten;
          } else if (resDichVuApi.result.loai == "ticket") {
            this.doiTuong = resDichVuApi.result.ve_dien_tu.ten;
          }
        } else if (resDichVuTourApi.result) {
          this.doiTuong = resDichVuTourApi.result.ten_tour;
        }
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-autocomplete.inline-input {
  width: 100%;
}
</style>
